module.exports = __webpack_public_path__ + "static/media/photo-h.b44875ce.png";